import { Api, Http } from '../../../models/index';
import { GetApi } from '../api/index';
import { CacheableResource } from '../CacheableResource';
import { GetResource } from '../GetResource';

export type PublicationData = {
    absolute_dates_time: {
        modified: string;
    };
    content: {
        rendered: string;
    };
    featured_img: string;
    featured_img_caption: string;
    title: {
        rendered: string;
    };
    author_meta: {
        author_link: string;
        display_name: string;
    };
    yoast_head_json: {
        og_url: string;
        og_site_name: string;
        twitter_misc: {
            'Est. reading time': string;
        };
    };
};

export class GetInsights extends CacheableResource<
    CacheableResource.Params & { slugId: string },
    { publicationData: PublicationData[] }
> {
    private getApi: GetApi;
    private getResource: GetResource<Api.Rel, { publicationData: PublicationData[] }>;

    constructor(http: Http) {
        super() /* istanbul ignore next */;
        this.getApi = new GetApi(http);
        this.getResource = new GetResource<Api.Rel, { publicationData: PublicationData[] }>(http);
    }

    protected doExecute({ slugId }): Promise<{ publicationData: PublicationData[] }> {
        return this.getApi.execute().then((api) => {
            return this.getResource
                .execute({
                    parent: api,
                    rel: 'insights/the-weekly-wire',
                    queryParams: { slugId }
                })
                .then((dashboard) => dashboard!);
        });
    }
}
